interface LoadingIndicatorProps {
  text?: string;
}

export function LoadingIndicator({ text }: LoadingIndicatorProps) {
  return (
    <div style={styles.container}>
      <div style={styles.dots}>
        <span style={{ ...styles.dot, animationDelay: '0s' }} />
        <span style={{ ...styles.dot, animationDelay: '0.2s' }} />
        <span style={{ ...styles.dot, animationDelay: '0.4s' }} />
      </div>
      {text && <span style={styles.text}>{text}</span>}
      <style>{`
        @keyframes typingDot {
          0%, 80%, 100% { opacity: 0.3; transform: scale(0.8); }
          40% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '4px 0',
  },
  dots: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    background: 'var(--primary)',
    animation: 'typingDot 1.4s infinite ease-in-out both',
    display: 'inline-block',
  },
  text: {
    fontSize: '0.86rem',
    color: 'var(--text-secondary)',
  },
};
